(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["caballero-brand-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHero(root) {
      if (root.dataset.caBheroReady === '1') return;
      root.dataset.caBheroReady = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-ca-slide]'));
      if (slides.length < 2) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ca-dot]'));
      var prev = root.querySelector('[data-ca-prev]');
      var next = root.querySelector('[data-ca-next]');
      var interval = parseInt(root.dataset.interval, 10) || 7000;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var autoplay = root.dataset.autoplay === 'true' && !reduce;
      var current = 0;
      var timer = null;

      root.style.setProperty('--ca-bhero-duration', (interval / 1000) + 's');

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === current;
          slide.classList.toggle('is-active', active);
          if (active) {
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        dots.forEach(function (dot, i) {
          var active = i === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          dot.classList.remove('is-running');
          if (active && autoplay) {
            void dot.offsetWidth;
            dot.classList.add('is-running');
          }
        });
      }

      function start() {
        if (!autoplay) return;
        stop();
        timer = window.setInterval(function () { show(current + 1); }, interval);
      }
      function stop() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }
      function go(index) { show(index); start(); }

      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { go(parseInt(dot.dataset.index, 10) || 0); });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      var startX = null;
      root.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        stop();
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var delta = e.changedTouches[0].clientX - startX;
        if (Math.abs(delta) > 44) { show(delta < 0 ? current + 1 : current - 1); }
        startX = null;
        start();
      }, { passive: true });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });

      show(0);
      start();
    }

    function initAll() {
      document.querySelectorAll('[data-ca-bhero]').forEach(initHero);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["caballero-product"]) return;
  try {
    
  (function () {
    function init() {
      var main = document.getElementById('ca-pdp-main');
      var stage = main ? main.closest('.ca-pdp__stage') : null;
      var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-ca-thumb]'));

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var url = thumb.getAttribute('data-full');
          if (!url || !main) return;
          if (stage) stage.classList.add('is-loading');
          var pre = new Image();
          pre.onload = function () {
            main.src = url;
            if (stage) stage.classList.remove('is-loading');
          };
          pre.onerror = function () { if (stage) stage.classList.remove('is-loading'); };
          pre.src = url;
          thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        });
      });

      var select = document.querySelector('[data-ca-variant-select]');
      var priceEl = document.querySelector('[data-ca-price]');
      var stockEl = document.querySelector('[data-ca-stock]');
      var addBtn = document.querySelector('[data-ca-add]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          if (!opt) return;
          var available = opt.getAttribute('data-available') === 'true';
          if (priceEl) priceEl.textContent = opt.getAttribute('data-price') || priceEl.textContent;
          if (stockEl) {
            stockEl.textContent = available ? 'Disponible · despacho a todo Chile' : 'Sin stock por ahora';
            stockEl.classList.toggle('is-in', available);
          }
          if (addBtn) {
            addBtn.disabled = !available;
            addBtn.textContent = available ? 'Agregar al carrito' : 'Agotado';
          }
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
